import { Link } from 'react-router-dom'
import { useQuery } from '@tanstack/react-query'
import { listNews } from '../../shared/api/news.api'
import { authorName, formatNewsDate } from './utils'

const WIDGET_LIMIT = 4

export function NewsFeedWidget() {
  const { data, isLoading } = useQuery({
    queryKey: ['news', { page: 1, limit: WIDGET_LIMIT }],
    queryFn: () => listNews({ page: 1, limit: WIDGET_LIMIT }),
    staleTime: 30_000,
  })

  return (
    <section className="rounded-xl border border-gray-200 bg-white p-4">
      <header className="flex items-center justify-between mb-3">
        <h2 className="text-sm font-semibold text-gray-900">Лента новостей</h2>
        <Link to="/news" className="text-xs text-brand-600 hover:text-brand-700">
          Все новости →
        </Link>
      </header>

      {isLoading ? (
        <div className="text-sm text-gray-400">Загружаем…</div>
      ) : !data || data.items.length === 0 ? (
        <div className="text-sm text-gray-400">Пока новостей нет.</div>
      ) : (
        <ul className="space-y-3">
          {data.items.map((p) => (
            <li key={p.id} className="border-b border-gray-100 last:border-0 pb-3 last:pb-0">
              <Link to={`/news?postId=${p.id}`} className="block group">
                <h3 className="text-sm font-medium text-gray-900 group-hover:text-brand-700 transition-colors">
                  {p.title}
                </h3>
                <p className="text-xs text-gray-500 mt-1 line-clamp-2 whitespace-pre-wrap">
                  {p.body}
                </p>
                <div className="flex items-center justify-between mt-1.5 text-[11px] text-gray-400">
                  <span>{authorName(p.author)}</span>
                  <time>{formatNewsDate(p.createdAt)}</time>
                </div>
              </Link>
            </li>
          ))}
        </ul>
      )}
    </section>
  )
}
